module.exports = __webpack_public_path__ + "uarm-images/tinymce-livecharts_big.png";